module.exports = __webpack_public_path__ + "img/heart.cf78bc76.svg";